import Badge, { BadgeProps } from '@mui/material/Badge';
import Button from '@mui/material/Button';
import { alpha, styled } from '@mui/material/styles';
import React, { memo } from 'react';
interface AppButtonsProps {
    title?: string;
    variant: 'contained' | 'text' | 'outlined';
    onClick?: any;
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
    middleIcon?: React.ReactNode;
    btnStyle?: object;
    badgeCount?: number;
    name?: string;
    value?: string | number;
    disabled?: boolean;
}

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: 10,
        top: 5,
        color: 'white',
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
        backgroundColor: '#FFA500'
    }
}));

const AppButtons: React.FC<AppButtonsProps> = ({ title, variant, onClick, startIcon, endIcon, middleIcon, btnStyle, badgeCount, name, value, disabled }) => {
    const style = {
        bgcolor: variant === 'contained' ? '#15cdcb' : variant === 'text' ? '#EBF3F4' : 'transparent',
        borderRadius: 3,
        textTransform: 'none',
        fontSize: 16,
        color: '#FCFCFC',
        fontWeight: '600',
        p: middleIcon ? 0 : '14px 25px',
        height: 48,
        mx: 1,
        boxShadow: '0px 0px 0px rgba(0, 0, 0,0.15 )',
        width: 'auto',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        '&:hover': {
            backgroundColor: variant === 'contained' ? alpha('#15cdcb', 0.9) : variant === 'text' ? alpha('#15cdcb4', 0.8) : alpha('#15cdcb', 0.1),
            boxShadow: 'none'
        },
        '&:active': {
            backgroundColor: variant === 'contained' ? alpha('#15cdcb', 0.9) : variant === 'text' ? alpha('#EBF3F4', 0.9) : alpha('#15cdcb', 0.2)
        }
    };
    return (
        <StyledBadge badgeContent={badgeCount}>
            <Button
                disabled={disabled}
                variant={variant}
                onClick={onClick}
                name={name}
                value={value}
                sx={{
                    ...style,
                    ...(variant === 'text' && { bgcolor: '#EBF3F4', color: '#1A1D1F' }),
                    ...btnStyle
                }}
                startIcon={startIcon}
                endIcon={endIcon}
            >
                {title}
                {middleIcon}
            </Button>
        </StyledBadge>
    );
};
export default memo(AppButtons);
